import React from "react";
import { ThemeProvider } from "styled-components";

import theme from "../../style/theme";
import Icons from "../../icons";
import GlobalCss from "../../style";

import { Validation } from "../Form";

import { Nav, Logo, Message, Center, StaffLines } from "./styles";
import { useIntl } from "react-intl";
import { IProps } from "./interfaces";

const NotSupported = ({ notSupported }: IProps) => {
    const intl = useIntl();
    return (
        <div>
            <ThemeProvider theme={theme}>
                <>
                    <GlobalCss />
                    <Nav>
                        <Logo>
                            <div>
                                <StaffLines>
                                    <svg width="100%" height="40" viewBox="0 -7.5 100 41" preserveAspectRatio="none">
                                        <line x1="0" x2="100" y1="1" y2="1"></line>
                                        <line x1="0" x2="100" y1="7" y2="7"></line>
                                        <line x1="0" x2="100" y1="13" y2="13"></line>
                                        <line x1="0" x2="100" y1="19" y2="19"></line>
                                        <line x1="0" x2="100" y1="25" y2="25"></line>
                                    </svg>
                                </StaffLines>
                                <Icons.Logo
                                    slogen={
                                        intl.locale === "hu" ? "tantermi digitális zeneoktatás" : "digital music education"
                                    }
                                    locale={intl.locale}
                                />
                            </div>
                        </Logo>
                    </Nav>
                    <Message>
                        {notSupported === "browsername" && (
                            <Center>
                                <div className={"Validation"}>
                                    <Validation
                                        plainText={
                                            intl.locale === "hu"
                                                ? "Nem támogatott böngésző!"
                                                : "This browser is not supported!"
                                        }
                                    />
                                </div>
                                <p>
                                    {intl.locale === "hu"
                                        ? "Kérjük, használj Chrome, Opera, Firefox vagy Safari böngészőt!"
                                        : "Please use Chrome, Opera, Firefox or Safari."}
                                </p>
                            </Center>
                        )}
                        {notSupported === "osversion" && (
                            <Center>
                                <div className={"Validation"}>
                                    <Validation
                                        plainText={
                                            intl.locale === "hu"
                                                ? "Nem támogatott Operációs rendszer verzió!"
                                                : "Operation System version is not supported!"
                                        }
                                    />
                                </div>
                                <p>
                                    {intl.locale === "hu"
                                        ? "Kérjük, frissítsd az operációs rendszeredet vagy használj másik eszközt!"
                                        : "Please update your operation system or use an other device"}
                                </p>
                            </Center>
                        )}
                    </Message>
                </>
            </ThemeProvider>
        </div>
    );
}

export default NotSupported;
